export default __webpack_public_path__ + "static/media/Helm of Conflagrant Flame.422f67e0.jpg";